/** The site has its policy in French and English only. */
export const privacyPolicyLocale = (language?: string) =>
  language?.startsWith("fr") ? "fr-FR" : "en-US";
